import { render } from "./ClubDealInfo.vue?vue&type=template&id=de565142&scoped=true&ts=true"
import script from "./ClubDealInfo.vue?vue&type=script&lang=ts"
export * from "./ClubDealInfo.vue?vue&type=script&lang=ts"

import "./ClubDealInfo.vue?vue&type=style&index=0&id=de565142&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de565142"]])

export default __exports__